import { trigger_interaction } from './Analytics';



//topics
export function selectTopic({ topicId }) {
    trigger_interaction('HOME', 'o', `TOPIC, ${topicId}`);
}
export function selectSeeAllTopics() {
    trigger_interaction('HOME', 'o', 'TOPIC, All');
}
export function selectSubTopic({ topicId, subTopicId }) {
    trigger_interaction('HOME', 'o', `SUBTOPIC, ${topicId}, ${subTopicId}`);
}
export function selectSubTopicAll({ topicId }) {
    trigger_interaction('HOME', 'o', `SUBTOPIC, ${topicId}, SelectAll`);
}
export function selectResetTopic() {
    trigger_interaction('HOME', 'o', 'TOPIC, Reset');
}
export function selectCdcHeader() {
    trigger_interaction('HOME', 'o', 'CDC_HEADER');
}
export function selectCdcHelpLink() {
    trigger_interaction('HOME', 'o', 'CDC_HELP_LINK');
}

export function selectSurvey({ survey }) {
    trigger_interaction('HOME', 'o', `SURVEY, ${survey}`);
}

export function selectSort({ sortType }) {
    trigger_interaction('HOME', 'o', `SORT, ${sortType}`);
}

export function selectLocation({ locationId }) {
    trigger_interaction('HOME', 'o', `LOCATION, ${locationId}`);
}


